export const getWebpPath = (path: string, withoutWebp?: boolean): string => {
    if (withoutWebp) return path;
    // Ищем расширение .jpg/.jpeg/.png перед началом query-параметров (?) или в конце строки
    return path.replace(/\.(jpg|jpeg|png)(?=\?|$)/i, '.webp');
    // return path.replace(/\.(jpg|jpeg|png)$/i, '.webp');
};
